import { formatDocument, getDocumentType, normalizeDocument } from "./document";

export default function formatCpfCnpj(cnpjCpf) {
    let document = normalizeDocument(cnpjCpf);
    if (!/[A-Z]/.test(document)) {
        document = document.padStart(getDocumentType(document) === 1 ? 11 : 14, "0");
    }
    return formatDocument(document);
}
